/* eslint-disable import/no-default-export */
import { combineReducers } from 'redux';

import boardSelector, { BoardSelectorState } from './board-selector';
import boardsMenu, { BoardsMenuState } from './boards-menu';
import closedBoards, { ClosedBoardsState } from './closed-boards';
import collapsibles, { CollapsiblesState } from './collapsibles';
import createMenu, { CreateMenuState } from './create-menu';
import errors, { ErrorState } from './errors';
import notificationsPane, {
  NotificationsPaneState,
} from './notifications-pane';
import overlay, { OverlayState } from './overlay';
import {
  MemberHomeProfileState,
  MemberHomeProfileReducer as memberHomeProfile,
} from 'app/gamma/src/modules/state/ui/member-home-profile';

export interface UiState {
  boardSelector: BoardSelectorState;
  boardsMenu: BoardsMenuState;
  closedBoards: ClosedBoardsState;
  collapsibles: CollapsiblesState;
  createMenu: CreateMenuState;
  errors: ErrorState;
  memberHomeProfile: MemberHomeProfileState;
  notificationsPane: NotificationsPaneState;
  overlay: OverlayState;
}

export default combineReducers({
  boardSelector,
  boardsMenu,
  closedBoards,
  collapsibles,
  createMenu,
  errors,
  memberHomeProfile,
  notificationsPane,
  overlay,
});
